import { useQuery } from "@tanstack/react-query";
import { COUNTRY_FALLBACK, listCountries, type CountrySetting } from "@/lib/countries.functions";

/** Aktiva säljländer från administrationen, med reservlista under laddning. */
export function useCountries(): CountrySetting[] {
  const { data } = useQuery({
    queryKey: ["countries"],
    queryFn: () => listCountries({ data: { all: false } }),
    staleTime: 10 * 60 * 1000,
  });
  return data && data.length ? data : COUNTRY_FALLBACK;
}
